import { getApiBaseUrl } from './apiConfig';

const LEGACY_API_ORIGINS = [
  'http://localhost:8000',
  'http://127.0.0.1:8000',
];

const rewriteLegacyApiUrl = (value) => {
  if (typeof value !== 'string') return value;

  const legacyOrigin = LEGACY_API_ORIGINS.find((origin) => value.startsWith(origin));
  if (!legacyOrigin) return value;

  return `${getApiBaseUrl()}${value.slice(legacyOrigin.length)}`;
};

/**
 * Route older API calls through the configured same-origin API in production.
 * The development URLs remain unchanged, while legacy fetch and Axios callers
 * continue to work behind the production HTTPS reverse proxy.
 */
export const installApiRequestUrlRewrite = () => {
  if (process.env.NODE_ENV !== 'production' || typeof window === 'undefined') return;

  const originalFetch = window.fetch.bind(window);
  window.fetch = (input, init) => {
    const inputUrl = typeof input === 'string' ? input : input?.url;
    const rewrittenUrl = rewriteLegacyApiUrl(inputUrl);

    if (rewrittenUrl === inputUrl) return originalFetch(input, init);

    const rewrittenInput = typeof input === 'string'
      ? rewrittenUrl
      : new Request(rewrittenUrl, input);

    return originalFetch(rewrittenInput, init);
  };

  const originalXhrOpen = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function open(method, url, ...options) {
    return originalXhrOpen.call(this, method, rewriteLegacyApiUrl(url), ...options);
  };
};

export default rewriteLegacyApiUrl;
